import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import vehicleValuation from '../../../../api/bank/vehicle-valuation';
import {
  DOCUMENT_TYPES_TECH_PASSPORT,
  DOCUMENT_TYPES_VIN_PHOTO_CAR_ASSESSMENT,
  DOCUMENT_TYPES_ODOMETER_PHOTO_CAR_ASSESSMENT,
} from '../../../../constants';
import alert from '../../../../helpers/alert';

const DocumentsForUsedCar = ({
  backHandler,
  loading,
  deal,
  chosenBankAppealId,
  chosenBankAppeal,
  setLoading,
  onSuccess,
  bankId,
}) => {
  const { uploadMultiple, uploading, progress, currentFileName, uploadQueue } = useDocumentUpload();

  const onNotarialDocumentsSubmit = async (values) => {
    if (!values['techPassport']) {
      alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¢ÐµÑÐ½Ð¸ÑÐµÑÐºÐ¸Ð¹ Ð¿Ð°ÑÐ¿Ð¾ÑÑ');
      return;
    }

    if (!values['vinPhoto']) {
      alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¤Ð¾ÑÐ¾ VIN-ÐºÐ¾Ð´Ð° Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð² Ð¿ÐµÑÐµÐ´Ð½ÐµÐ¹ ÑÐ°ÑÑÐ¸ ÐºÑÐ·Ð¾Ð²Ð°');
      return;
    }

    if (!values['odometerPhoto']) {
      alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð¤Ð¾ÑÐ¾ Ð¾Ð´Ð¾Ð¼ÐµÑÑÐ°, Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑÐµÐ³Ð¾ Ð¿ÑÐ¾Ð±ÐµÐ³');
      return;
    }

    const filesToUpload = [
      {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_TECH_PASSPORT,
        file: values['techPassport'],
      },
      {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_VIN_PHOTO_CAR_ASSESSMENT,
        file: values['vinPhoto'],
      },
      {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_ODOMETER_PHOTO_CAR_ASSESSMENT,
        file: values['odometerPhoto'],
      },
    ];

    try {
      await uploadMultiple(filesToUpload);
      setLoading(true);
      if (chosenBankAppeal?.bankUniqueId) {
        try {
          await vehicleValuation(chosenBankAppeal.bankUniqueId);
          onSuccess();
        } catch (e) {
          alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð·Ð°Ð¿ÑÐ¾ÑÐµ Ð¾ÑÐµÐ½ÐºÐ¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¾Ñ Ð±Ð°Ð½ÐºÐ°');
          setLoading(false);
          return;
        }
      }
    } catch (err) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²');
      setLoading(false);
    }
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} queue={uploadQueue} />;
  }

  return (
    <div>
      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        hint="ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼ÑÐµ Ð¿ÑÐ¸ Ð¿ÐµÑÐ²Ð¸ÑÐ½Ð¾Ð¹ ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¸ Ð°Ð²ÑÐ¾"
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            text: 'Ð¢ÐµÑÐ½Ð¸ÑÐµÑÐºÐ¸Ð¹ Ð¿Ð°ÑÐ¿Ð¾ÑÑ',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'techPassport',
            id: 'Ð¢ÐµÑÐ½Ð¸ÑÐµÑÐºÐ¸Ð¹ Ð¿Ð°ÑÐ¿Ð¾ÑÑ',
            component: DocsInputNew,
          },
          {
            text: 'Ð¤Ð¾ÑÐ¾ VIN-ÐºÐ¾Ð´Ð° Ð½Ð° Ð¿Ð°Ð½ÐµÐ»Ð¸ Ð² Ð¿ÐµÑÐµÐ´Ð½ÐµÐ¹ ÑÐ°ÑÑÐ¸ ÐºÑÐ·Ð¾Ð²Ð°',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¾',
            name: 'vinPhoto',
            id: 'Ð¤Ð¾ÑÐ¾ VIN-ÐºÐ¾Ð´Ð°',
            component: DocsInputNew,
          },
          {
            text: 'Ð¤Ð¾ÑÐ¾ Ð¾Ð´Ð¾Ð¼ÐµÑÑÐ°, Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑÐµÐ³Ð¾ Ð¿ÑÐ¾Ð±ÐµÐ³',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¾',
            name: 'odometerPhoto',
            id: 'Ð¤Ð¾ÑÐ¾ Ð¾Ð´Ð¾Ð¼ÐµÑÑÐ°',
            component: DocsInputNew,
          },
        ]}
        onSubmit={onNotarialDocumentsSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default DocumentsForUsedCar;
